/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Should_The_Ai_Represent_ThInputs */

const en_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How should the AI represent this specific listing? E.g. Focus on the low mileage and mint condition.`)
};

const es_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo debería la IA representar esta propiedad específica? Ej. 'Céntrate en la privacidad de la finca y la proximidad al puerto deportivo.'`)
};

const fr_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l'IA doit-elle représenter ce bien spécifique ? Ex. 'Concentrez-vous sur l'intimité du domaine et la proximité de la marina.'`)
};

const de_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie soll die KI diese spezifische Immobilie repräsentieren? Z.B. 'Fokussiere dich auf die Privatsphäre des Anwesens und die Nähe zum Yachthafen.'`)
};

const ja_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIはこの特定の物件をどのように表現すべきですか？ 例: 'この土地のプライバシー性とマリーナへの近さを強調してください。'`)
};

const zh_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 应该如何展示这个特定的房产？例如：'侧重于庄园的隐私性和靠近码头的地理优势。'`)
};

const ar_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف ينبغي للذكاء الاصطناعي تقديم هذه العقار تحديداً؟ مثال: 'ركز على خصوصية العقار والقرب من المرسى.'`)
};

const id_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana AI harus merepresentasikan listing khusus ini? Mis. Fokus pada jarak tempuh rendah dan kondisi sangat mulus.`)
};

const it_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come dovrebbe l'IA presentare questa specifica proprietà? Es. 'Concentrati sulla privacy della tenuta e sulla vicinanza al porto.'`)
};

const ru_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как ИИ должен представить этот конкретный объект недвижимости? Например, 'Сфокусируйтесь на приватности поместья и близости к пристани.'`)
};

const pt_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a IA deve representar esta propriedade específica? Ex. 'Concentre-se na privacidade da propriedade e na proximidade da marina.'`)
};

const ko_how_should_the_ai_represent_th = /** @type {(inputs: How_Should_The_Ai_Represent_ThInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI가 이 특정 부동산을 어떻게 표현해야 할까요? 예: '이 주택의 사생활 보호와 마리나와의 접근성에 초점을 맞추세요.'`)
};

/**
* | output |
* | --- |
* | "How should the AI represent this specific listing? E.g. Focus on the low mileage and mint condition." |
*
* @param {How_Should_The_Ai_Represent_ThInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const how_should_the_ai_represent_th = /** @type {((inputs?: How_Should_The_Ai_Represent_ThInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Should_The_Ai_Represent_ThInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_should_the_ai_represent_th(inputs)
	if (locale === "es") return es_how_should_the_ai_represent_th(inputs)
	if (locale === "fr") return fr_how_should_the_ai_represent_th(inputs)
	if (locale === "de") return de_how_should_the_ai_represent_th(inputs)
	if (locale === "ja") return ja_how_should_the_ai_represent_th(inputs)
	if (locale === "zh") return zh_how_should_the_ai_represent_th(inputs)
	if (locale === "ar") return ar_how_should_the_ai_represent_th(inputs)
	if (locale === "id") return id_how_should_the_ai_represent_th(inputs)
	if (locale === "it") return it_how_should_the_ai_represent_th(inputs)
	if (locale === "ru") return ru_how_should_the_ai_represent_th(inputs)
	if (locale === "pt") return pt_how_should_the_ai_represent_th(inputs)
	return ko_how_should_the_ai_represent_th(inputs)
});